<template>
  <div class="content" style="overflow:auto">
    <el-row>
      <el-col :span="24" style="text-align: left;padding: 20px;border-bottom: 1px solid #ddd;">
        <a class="go_back" @click="goBack">
          <i class="el-icon-back"></i> 返回
        </a>
      </el-col>
    </el-row>
    <div style="padding-bottom:100px;margin-left:10%">
      <el-row style="padding:10px 0px;margin-top:20px;" v-if="port!='4'">
        <el-col :span="24">
          <label class="layui-form-label">巡查项目</label>
          <label class="layui-form-label" style="text-align: center;margin-right: 50px;">{{info.projectName}}</label>
        </el-col>
      </el-row>
      <el-row style="padding:10px 0px;margin-top:20px;">
        <el-col :span="8">
          <label class="layui-form-label">巡查人</label>
          <label class="layui-form-label" style="text-align: center;margin-right: 50px;">{{info.reportName}}</label>
        </el-col>
        <el-col :span="13">
          <label class="layui-form-label">巡查时间</label>
          <label class="layui-form-label"
            style="color:#0085FF;width: 200px;text-align: center;">{{info.reportDate}}</label>
        </el-col>
      </el-row>
      <el-row style="padding:10px 0px;margin-top:20px;">
        <el-col :span="8">
          <label class="layui-form-label">问题性质</label>
          <label class="layui-form-label" style="text-align: center;margin-right: 50px;" >{{info.priorityName}}</label>
          <!-- <label class="layui-form-label" style="text-align: center;margin-right: 50px;" v-if="info.type==2">重大隐患</label>
          <label class="layui-form-label" style="text-align: center;margin-right: 50px;" v-if="info.type==9">其他</label> -->
        </el-col>
      </el-row>
      <el-row style="padding:50px 20px;">
        <el-col :span="15" style="display:flex;">
          <label class="layui-form-label">巡查事项</label>
          <div class="layui-input-block" style="flex:1;background: rgba(244, 244, 244, 1);">
            <el-input type="textarea" :rows="8" v-model="info.description" readonly autosize style="font-size:20px">
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row style="padding:10px 20px;">
        <el-col :span="16" style="display:flex;">
          <label class="layui-form-label">现场图片</label>
          <div class="layui-input-block" style="flex:1;height:auto;">
            <img v-for="x in imgdata" :src="imgPath+x" :key="x" id="photo"
              style="width:auto; height:400px;margin: 10px;" />
          </div>
        </el-col>
      </el-row>
      <el-row style="padding:10px 20px;">
        <el-col :span="16" style="display:flex;">
          <label class="layui-form-label">巡查地点</label>
          <div class="layui-input-block" style="flex:1;height:auto;">
          {{info.address}}
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="handel">处理信息</div>
    <div class="build-table">
      <el-table :data="tableData" border style="width: 100%">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100">
          <template prop="index" width="60px" slot-scope="scope">
            <span>{{scope.row.index}}</span>
          </template>
        </el-table-column>
        <el-table-column label="处理时间">
          <template slot-scope="scope">
            <span>{{scope.row.processDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="流程">
          <template slot-scope="scope">
            <span v-if="scope.row.apprFlag==0" style="color:#22a5f1 ;">责任人:{{scope.row.processName}}</span>
            <span v-else-if="scope.row.apprFlag==1" style="color:#17a05d ;">确认人:{{scope.row.processName}}</span>
            <span v-else style="color:#fed04f ;">发起人:{{scope.row.processName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="处理结果" width="800">
          <template slot-scope="scope">
            <span v-if="scope.row.processStatus==0">{{scope.row.processStatus}}</span>
            <span v-else>{{scope.row.processDesc}}</span>
            <div style="display:flex;flex-wrap: wrap;">
              <el-image 
                v-for="img in scope.row.picUrls" :key="img"
                style="width:50px;height:50px;margin:10px;"
                :src="imgPath+img" 
                :preview-src-list="[imgPath+img]">
              </el-image>
              <!-- <img :src="imgPath+img" style="width:auto;height:50px;margin:10px;" v-for="img in scope.row.picUrls" :key="img" /> -->
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="">
          <template slot-scope="scope">
           
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="确认意见">
          <template slot-scope="scope">
            <span>{{scope.row.handleDesc}}</span>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="myhandle" v-if="type==2&&handle==2">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="处理结果" v-if="info.status==0">
          <el-input v-model="formInline.processDesc" type="textarea" :rows="5" placeholder="请输入处理结果"></el-input>
        </el-form-item>
        <el-form-item label="处理图片" v-if="info.status==0">
          <el-upload :action="uploadphotoUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
            :headers="uploadHead" :data="uploadphotoData" :on-success="handleIconSuccess">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="info.status==2"  label="确认结果">
          <el-radio-group v-model="formInline.processStatus">
            <el-radio label="1">同意</el-radio>
            <el-radio label="2">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="argee()">提交</el-button>
    </div>

  </div>
</template>
<script>
  import myHttp from "../../untils/port.js"
  import util from "../../untils/util.js"
  import base from '../../untils/base'
  export default {
    data() {
      return {
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        info: {
          reportName: '',
          reportDate: '',
          description: '',
        },
        imgdata: [],
        imgPath: base.httpCtx,
        tableData: [],
        id: "",
        dataText: "数据加载中...",
        type: '',
        port: '',
        handle:'',
        formInline: {
          id:'',
          picUrls: '',
          processDesc: '',
          processStatus: ''
        },
        fileList: [],
        types:[]
      }
    },
    mounted() {
      this.id = this.$route.params.id;
      this.type = this.$route.params.type
      this.handle = this.$route.params.handle
      this.port = util.session.get('roleId')
      this.getDictByType()
      this.getInfo();

    },
    methods: {
      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          console.log(opt)
          console.log(res)
          this.fileList = opt
          // var picUrls =[]
          // for(var i=0;i<opt.length;i++){
          //   picUrls.push(opt[i].response.data.saveUrls)
          // }
          // console.log(picUrls)
        } else {
          this.$message.error(res.msg)
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleRemove(file, fileList) {

        
        console.log(fileList)
        this.fileList = fileList
      },
      getInfo() {
        var that = this;
        // if (this.type != 4 ||this.type != 5) {
        //   var flag = ''
        // } else {
        //   var flag = 1
        // }
        myHttp.getQsInfoById({
          id: this.id,
          flag:'1'
        }).then(function (resp) {
          if (resp.data.code == "200") {
            for(let a=0;a<that.types.length;a++){
              if( resp.data.data.qs.priority == that.types[a].value){
                resp.data.data.qs.priorityName = that.types[a].label
              }    
            }
            that.info = resp.data.data.qs || that.info;
            // console.log(that.info)
            var list = undefined == resp.data.data.qs.picUrls || '' == resp.data.data.qs.picUrls ? [] : resp.data.data.qs.picUrls.split(',');
            that.imgdata = list;
            var obj={
              processName: that.info.reportName,
              processDate:that.info.reportDate,

            }
            var proList = resp.data.data.processList || [];
            var process = resp.data.data.process
            if(process){
              that.formInline.id=process.id
            }
            proList.unshift(obj)
            for (var i = 0; i < proList.length; i++) {
              proList[i].index = i + 1
              proList[i].picUrls = proList[i].picUrls ? proList[i].picUrls.split(',') : [];
            }
          
            that.tableData = proList;
            if (that.tableData.length == 0) {
              that.dataText = '暂无数据'
            }
          }
        });
      },
      // 处理
      argee() {
        var picUrls = []
        var that = this
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].response.data.saveUrls)
        }
        // console.log(picUrls.toString())
        this.formInline.picUrls = picUrls.toString()
        if(this.info.status==2){
          if(this.formInline.processStatus==1){
            this.formInline.processDesc='同意'
          }else{
            this.formInline.processDesc='不同意'
          }
        }else{
          this.formInline.processStatus=1
        }
        console.log(this.formInline)
        myHttp
          .dealQs(this.formInline)
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.$router.go(-1);
            }
          })
      },
         // 获取问题列表
         getDictByType() {
        // getDictByType
        var that = this
        myHttp
          .getDictByType({
            type: 'qs_priority'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.types = resp.data.data.dictList
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      goBack() {
        this.$router.go(-1);
      }
    }
  }
</script>
<style scoped>
  #lookAdd .layui-form-label,
  .dataDetails .layui-form-label {
    width: 105px;
  }

  .dataDetails .layui-input {
    margin-left: 5px;
  }

  .dataDetails .layui-textarea {
    width: 900px;
    height: 130px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    border: 0px;
  }

  .dataDetails .layui-upload-drag {
    width: 400px;
    height: 130px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    border: 0px;
  }

  #lookAdd .layui-textarea {
    width: 800px;
    height: 130px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    border: 0px;
  }

  #lookAdd .layui-upload-drag {
    width: 299px;
    height: 100px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    border: 0px;
    margin-left: 5px;
  }

  .content {
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
    text-align: left;
  }

  .build-table {
    position: relative;
    width: 94%;
    margin: 0 auto;
    /* height: calc( 100% - 160px ); */
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .go_back {
    cursor: pointer;
    color: #4d87f5;
  }

  .go_back:hover {
    color: #17b2fe;
  }

  .layui-form-label {
    margin-right: 80px;
    min-width: 100px;
    display: inline-block;
    text-align: right;
    font-size: 20px;
  }

  .handel {
    width: 100%;
    background: #e7f1fb;
    /* color: #fff; */
    padding: 20px;
  }

  .myhandle {
    width: 90%;
    margin: auto;
    padding: 20px;
  }

  .demo-form-inline {
    width: 100%;
  }

  .content>>>.el-form--inline .el-form-item__content {
    width: 100% !important;
  }

  .content>>>.el-form--inline .el-form-item {
    width: 100% !important;
  }
</style>